import LayoutWithSideMenu from '@/layout/layoutWithSideMenu/index.vue'


export const noticeManage = {
  path: '/noticeManage/',
  name: 'noticeManage',
  component: LayoutWithSideMenu,
  meta: {
    title: '通知管理'
  },
  children: [{
    path: 'technicalRenovationNotice',
    name: 'technicalRenovationNotice',
    component: () => import('@/views/noticeManage/technicalRenovationNotice/index.vue'),
    meta: {
      title: '技改通知'
    }
  }, 
  // {
  //   path: 'technicalRenovationNotice/info',
  //   name: 'technicalRenovationNoticeInfo',
  //   component: () => import('@/views/noticeManage/technicalRenovationNotice/components/addOrEdit.vue'),
  //   meta: {
  //     title: '技改通知详情'
  //   }
  // }, 
  {
    path: 'projectBreakdown',
    name: 'projectBreakdown',
    component: () => import('@/views/noticeManage/projectBreakdown/index.vue'),
    meta: {
      title: '项目分解'
    }
  }, {
    path: 'projectBreakdown/info',
    name: 'projectBreakdownInfo',
    component: () => import('@/views/noticeManage/projectBreakdown/components/addOrEdit.vue'),
    meta: {
      title: '项目分解'
    }
  }, {
    path: 'workOrderAssignment',
    name: 'workOrderAssignment',
    component: () => import('@/views/noticeManage/workOrderAssignment/index.vue'),
    meta: {
      title: '工单指派'
    }
  }, {
    path: 'workOrderFilling',
    name: 'workOrderFilling',
    component: () => import('@/views/noticeManage/workOrderFilling/index.vue'),
    meta: {
      title: '工单填报'
    }
  },  {
    path: 'qualityInspection',
    name: 'qualityInspection',
    component: () => import('@/views/noticeManage/qualityInspection/index.vue'),
    meta: {
      title: '工单质检'
    }
  }, {
    path: 'qualityInspectionCard',
    name: 'qualityInspectionCard',
    component: () => import('@/views/noticeManage/qualityInspectionCard/index.vue'),
    meta: {
      title: '质检卡片'
    }
  },

  ]
}